import {Component, Input, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {IMPGalleryCardSubModule} from "../marketing-page.models";
import {MarketingPageUtil} from "../marketing-page-util";
import {ICartImage} from "../../cart/catalog/catalog-models";
import {CartUtil} from "../../cart/cart-util";
import {Constants} from "../../constants";

@Component({
    selector: 'gallery-sub-cards',
    templateUrl: './gallery-sub-cards.component.html',
    styleUrls: ['./gallery-sub-cards.component.scss'],
    standalone: false
})
export class GallerySubCardsComponent extends UsanaObject implements OnInit {

    @Input() componentData: IMPGalleryCardSubModule;
    @Input() parentCardName: string;
    @Input() pageUrl: string;
    @Input() useLocaleOverride: boolean;

    translationRoot: string;
    mobileImagePath: string;
    buttonType: string;
    callToActionUrl: string;

    constructor(loggerService: LoggerService) {
        super(
            loggerService
        );
    }

    ngOnInit(): void {
        const combinedNames = this.parentCardName + '.' + this.componentData.name;
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, combinedNames);
        const cartImages: ICartImage[] = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.mobileImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_MOBILE);
        this.buttonType = MarketingPageUtil.getButtonTypeClass(this.componentData.buttonType);
        if(this.componentData.countryDetails?.length > 0) {
            this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;
        }
    }

    callToActionClick(url: string) {
        window.location.href = this.callToActionUrl;
    }
}
